var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('h1',{staticClass:"not-found__header"},[_vm._v(" 404 ")]),_c('p',{staticClass:"not-found__text"},[_vm._v(" We could not find that page. ")]),_c('BaseButton',{on:{"click":_vm.goHome}},[_vm._v(" Return Home ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }